import React from "react";
import { Link } from "react-router-dom";
import { Phone, Mail, MapPin, Cookie } from "lucide-react";
import { useI18n } from "../../i18n/I18nContext";
import { useConsent } from "../../context/ConsentContext";

const PHONE = "450-736-0748";

export default function Footer() {
  const { t, pick } = useI18n();
  const { openCenter } = useConsent();

  const nav = [
    { to: "/la-residence", label: t("nav.residence") },
    { to: "/services", label: t("nav.services") },
    { to: "/milieu-de-vie", label: t("nav.milieu") },
    { to: "/admission", label: t("nav.admission") },
    { to: "/galerie", label: t("nav.gallery") },
    { to: "/carrieres", label: t("nav.careers") },
  ];
  const legal = [
    { to: "/politique-de-confidentialite", label: t("legal.privacy") },
    { to: "/politique-sur-les-temoins", label: t("legal.cookies") },
    { to: "/gouvernance-des-renseignements", label: t("legal.governance") },
    { to: "/declaration-accessibilite", label: t("legal.accessibility") },
    { to: "/conditions-utilisation", label: t("legal.terms") },
  ];

  return (
    <footer className="bg-[#1E293B] text-white/90" data-testid="site-footer">
      <div className="mx-auto grid max-w-6xl gap-10 px-5 py-14 sm:px-8 md:grid-cols-4">
        <div className="md:col-span-1">
          <p className="font-display text-2xl text-white">Résidence Doux Instants</p>
          <p className="mt-2 text-sm text-white/70">{t("footer.tagline")}</p>
        </div>
        <div>
          <h3 className="mb-3 text-sm font-semibold uppercase tracking-wide text-[#9CAF88]">{t("footer.nav")}</h3>
          <ul className="space-y-2 text-sm">
            {nav.map((l) => (
              <li key={l.to}><Link to={l.to} className="text-white/80 hover:text-white">{l.label}</Link></li>
            ))}
          </ul>
        </div>
        <div>
          <h3 className="mb-3 text-sm font-semibold uppercase tracking-wide text-[#9CAF88]">{t("footer.legal")}</h3>
          <ul className="space-y-2 text-sm">
            {legal.map((l) => (
              <li key={l.to}><Link to={l.to} className="text-white/80 hover:text-white">{l.label}</Link></li>
            ))}
          </ul>
        </div>
        <div>
          <h3 className="mb-3 text-sm font-semibold uppercase tracking-wide text-[#9CAF88]">{t("footer.contactUs")}</h3>
          <ul className="space-y-3 text-sm">
            <li className="flex items-start gap-2"><MapPin className="mt-0.5 h-4 w-4 text-[#9CAF88]" />
              <span>4825, rue Cyrille Delage<br />Laval (Auteuil), QC</span></li>
            <li><a href={`tel:${PHONE}`} className="flex items-center gap-2 hover:text-white" data-testid="footer-call">
              <Phone className="h-4 w-4 text-[#9CAF88]" /> {PHONE}</a></li>
            <li><a href="mailto:doux.instants.senc@gmail.com" className="flex items-center gap-2 hover:text-white">
              <Mail className="h-4 w-4 text-[#9CAF88]" /> doux.instants.senc@gmail.com</a></li>
          </ul>
          <button onClick={openCenter} data-testid="footer-manage-cookies"
            className="mt-4 inline-flex items-center gap-2 rounded-full border border-white/25 px-4 py-2 text-sm font-medium text-white hover:bg-white/10">
            <Cookie className="h-4 w-4" /> {t("common.manageCookies")}
          </button>
        </div>
      </div>
      <div className="border-t border-white/10">
        <div className="mx-auto max-w-6xl px-5 py-6 sm:px-8">
          <p className="text-xs text-white/50">{t("footer.dataNotice")}</p>
          <p className="mt-3 text-xs text-white/50">
            © {new Date().getFullYear()} Les Doux Instants S.E.N.C. · {t("footer.rights")} ·
            <Link to="/admin" className="ml-1 underline hover:text-white/80" data-testid="footer-admin-link">Admin</Link>
          </p>
        </div>
      </div>
    </footer>
  );
}
